(function () {
  const translations = {
    'most_relevant': 'Más relevantes',
    'relevance': 'Más relevantes',
    'Availability': 'Disponibilidad',
    'Best Selling': 'Más vendidos',
    'Alphabetically, A-Z': 'Alfabético, A-Z',
    'Alphabetically, Z-A': 'Alfabético, Z-A',
    'Price, low to high': 'Precio: menor a mayor',
    'Price, high to low': 'Precio: mayor a menor',
    'Date, new to old': 'Más recientes',
    'Date, old to new': 'Más antiguos',
    '% Sale off': 'Mayor descuento'
  };

  function translateText() {
    document
      .querySelectorAll('option, button, span, div, li, a')
      .forEach(function (el) {
        const text = el.textContent.trim().replace(/\s+/g, ' ');

        if (translations[text]) {
          el.textContent = translations[text];
        }
      });

    document.querySelectorAll('option').forEach(function (option) {
      const value = option.value.trim();

      if (translations[value]) {
        option.textContent = translations[value];
      }
    });
  }

  function hideShow48() {
    function norm(text) {
      return (text || '')
        .trim()
        .replace(/\s+/g, ' ')
        .toLowerCase();
    }

    function hide(el) {
      if (!el) return;

      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('width', '0', 'important');
      el.style.setProperty('min-width', '0', 'important');
      el.style.setProperty('margin', '0', 'important');
      el.style.setProperty('padding', '0', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
    }

    document.querySelectorAll('body *').forEach(function (el) {
      const text = norm(el.textContent);

      if (!text.includes('show') || !text.includes('48')) return;

      if (
        text.includes('más relevantes') ||
        text.includes('disponibilidad')
      ) {
        return;
      }

      const rect = el.getBoundingClientRect();

      if (
        rect.width > 40 &&
        rect.width < 260 &&
        rect.height > 20 &&
        rect.height < 90
      ) {
        hide(el);
        return;
      }

      const control =
        el.closest('button') ||
        el.closest('[role="button"]') ||
        el.closest('[class*="select"]') ||
        el.closest('[class*="dropdown"]') ||
        el.closest('[class*="filter"]') ||
        el.closest('div');

      if (control) {
        const controlText = norm(control.textContent);
        const controlRect = control.getBoundingClientRect();

        if (
          controlText.includes('show') &&
          controlText.includes('48') &&
          !controlText.includes('más relevantes') &&
          controlRect.width < 300
        ) {
          hide(control);
        }
      }
    });

    document.querySelectorAll('body *').forEach(function (el) {
      const text = norm(el.textContent);

      if (text.includes('más relevantes')) {
        const previous = el.previousElementSibling;

        if (
          previous &&
          norm(previous.textContent).includes('show') &&
          norm(previous.textContent).includes('48')
        ) {
          hide(previous);
        }
      }
    });
  }

  function runTriamontoFixes() {
    translateText();
    hideShow48();
  }

  document.addEventListener(
    'DOMContentLoaded',
    runTriamontoFixes
  );

  document.addEventListener(
    'globoFilterRenderCompleted',
    runTriamontoFixes
  );

  document.addEventListener(
    'gspfRenderCompleted',
    runTriamontoFixes
  );

  document.addEventListener('click', function () {
    setTimeout(runTriamontoFixes, 100);
    setTimeout(runTriamontoFixes, 500);
  });

  const observer = new MutationObserver(function () {
    clearTimeout(window.__triamontoFixTimer);

    window.__triamontoFixTimer =
      setTimeout(runTriamontoFixes, 100);
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  setTimeout(runTriamontoFixes, 500);
  setTimeout(runTriamontoFixes, 1500);
  setTimeout(runTriamontoFixes, 3000);
})();